import { render } from "./GtrVipToLite.vue?vue&type=template&id=023e1954&ts=true"
import script from "./GtrVipToLite.vue?vue&type=script&lang=ts"
export * from "./GtrVipToLite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__